import { StyleSheet } from 'react-native';
import { fontWeights } from '../../styles/typographyTokens';

/**
 * CORE-528, QA-возврат 09.08.2026 — «UI у мастера и у со-ведущего разный в
 * части кнопок действий».
 *
 * Ведущий и со-ведущий сидят в одном эфире, но их панели управления писались
 * порознь: `MasterLivePublisher` через свои `styles.ctrlBtn`, `GuestRoomScreen`
 * — инлайновыми объектами прямо в разметке. Общие кнопки (микрофон, камера,
 * участники, выход) в итоге разъехались по всему, что можно было задать
 * числом:
 *
 *   | | ведущий | со-ведущий |
 *   |---|---|---|
 *   | кнопка | 52×52, r26 | 48×48, r24 |
 *   | фон    | rgba(255,255,255,0.2) + blur | rgba(255,255,255,0.15) |
 *   | «выключено» | rgba(239,68,68,0.6) | сплошной #DC2626 |
 *   | пилюля выхода | 24/14 | 18/12 |
 *
 * Здесь лежит одно правило на обе поверхности. За канон взят вид ведущего:
 * его панель QA только что принял, и менять её ради симметрии значило бы
 * трогать то, что работает.
 *
 * РОЛЕВЫЕ кнопки сюда НЕ переезжают. Демонстрация экрана, настройки, практика,
 * приглашение и «Завершить» есть только у ведущего, и вопрос, что из этого
 * положено со-ведущему, — продуктовый, а не про стили. Общий вид кнопки и
 * состав панели — разные решения, и смешивать их в одном модуле значит
 * получить третий набор правил вместо одного.
 */

/** Размер иконки внутри круглой кнопки. Одно число на обе панели: у ведущего
 *  микрофон и камера были 24, остальные 22 — расхождение внутри одной строки. */
export const LIVE_CONTROL_ICON_SIZE = 22;

/** Отступ панели от низа. У со-ведущего было 24, у ведущего 40 — на глаз
 *  панели стояли на разной высоте при переходе между ролями. */
export const LIVE_CONTROL_BAR_BOTTOM = 40;

export const liveControlStyles = StyleSheet.create({
    /** Круглая кнопка панели в покое. */
    ctrlBtn: {
        width: 52,
        height: 52,
        borderRadius: 26,
        backgroundColor: 'rgba(255,255,255,0.2)',
        alignItems: 'center',
        justifyContent: 'center',
        backdropFilter: 'blur(10px)',
    } as any,
    /** Выключенное устройство — микрофон или камера. */
    ctrlBtnDanger: {
        backgroundColor: 'rgba(239, 68, 68, 0.6)',
    },
    /** Включённый режим — открытая панель, идущая демонстрация. */
    ctrlBtnActive: {
        backgroundColor: 'rgba(232, 93, 4, 0.7)',
    },
    /** Счётчик в углу кнопки (зрители у со-ведущего, участники у ведущего). */
    ctrlBtnBadge: {
        position: 'absolute',
        top: 4,
        right: 4,
        minWidth: 18,
        height: 18,
        paddingHorizontal: 5,
        borderRadius: 9,
        backgroundColor: '#E98245',
        alignItems: 'center',
        justifyContent: 'center',
    } as any,
    ctrlBtnBadgeText: {
        color: '#FFF',
        fontSize: 10,
        fontWeight: fontWeights.bold,
        lineHeight: 12,
    } as any,
    /** Пилюля выхода: «Завершить» у ведущего, «Покинуть» у со-ведущего.
     *  Действия разные по смыслу и намеренно остаются разными по подписи —
     *  одинаковой обязана быть только форма. */
    exitBtn: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: 24,
        paddingVertical: 14,
        borderRadius: 24,
        backgroundColor: '#DC2626',
        gap: 8,
    } as any,
    exitBtnText: {
        color: '#FFF',
        fontWeight: fontWeights.bold,
        fontSize: 14,
    } as any,
});
